import { createStore } from 'vuex'

export default createStore({
    state: {
        snack: '',
        color: '',
    },
    mutations: {
        setColor (state, color) {
          state.color = color
        },
        setSnack (state, snack) {
          state.snack = snack
        },
        showSnack (state, color, snack) {
          state.color = color
          state.snack = snack
        }
    }
})
